import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Radio, makeStyles } from '@material-ui/core'

import { PRIMARY, SECONDARY } from 'app/constants/input'

const useStyles = makeStyles((theme) => ({
  primary: {
    '&.MuiRadio-root:not(.Mui-disabled) > span.MuiIconButton-label': {
      color: 'currentcolor',
    },
    '&.MuiRadio-root': {
      color: theme.colors['grey-100'] + '!important',
    },
    '&.Mui-checked': {
      color: theme.colors['primary'] + '!important',
    },
    '&.MuiRadio-indeterminate': {
      color: theme.colors['primary'] + '!important',
    },
    '&.MuiIconButton - colorSecondary': {
      color: theme.colors['grey-100'] + '!important',
    },
  },
  secondary: {
    '&.MuiRadio-root:not(.Mui-disabled) > span.MuiIconButton-label': {
      color: 'currentcolor',
    },
    '&.MuiRadio-root': {
      color: theme.colors['grey-100'] + '!important',
    },
    '&.Mui-checked': {
      color: theme.colors['secondary'] + '!important',
    },
    '&.MuiRadio-indeterminate': {
      color: theme.colors['secondary'] + '!important',
    },
    '&.MuiIconButton - colorSecondary': {
      color: theme.colors['grey-100'] + '!important',
    },
  },
}))

const Radios = ({ color = PRIMARY, className, ...rest }) => {
  const classes = useStyles()

  const handleType = (color) => {
    switch (color) {
      case PRIMARY:
        return classes.primary
      case SECONDARY:
        return classes.secondary
      default:
        return
    }
  }

  return <Radio className={clsx(handleType(color), className)} {...rest} />
}

Radios.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
}
export default Radios
